﻿import { ICenter } from './center';
import { IDonorLogistics } from './donor-logistics';
import { IHlaData } from './hla-data';
import { IAdpVoucherHolder } from './adp-voucher-holder';
import { ICluster, IRecipient, ISingleEpletMmRisk } from '.';
import { AboASubType, AboAbSubType, YesNoUnknown } from '../enums';

export interface IDonor {
    id: number,
    donationTypeId: number,
    donationTypeAbbreviation: string,
    isDeleted: boolean,
    donorTypeId: number,
    donorType: string,
    pairStatus: string,

    isActive: boolean,
    isExportable: boolean,
    isViableBridge: boolean,
    isInDonorFollowup: boolean,
    isInFollowupProgram: boolean,
    nddStatus: number,
    isWorkedUp: number,
    testStatus: number,
    dateOfEvaluation: string,
    earliestSurgeryDateTime: string,
    latestSurgeryDateTime: string,
    donationDate: string,
    donationStartDate: string,
    donationEndDate: string,
    gender: string,
    race: string,
    alias: string,
    hasFrozenSamples: boolean,
    hasSamplesAtViracor: boolean,
    cryoStoredAtNkrLabDateTime: string,
    hasCtScanOnline: boolean,
    lastCryoOrder: string,
    unosId: string,
    isWillingToTravel: boolean,
    crossReferenceHint: string,
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    phone1: string,
    phone2: string,
    email: string,
    fullName: string,
    phiAddr1: string,
    phiAddr2: string,
    phiCity: string,
    phiState: string,
    phiPostalCode: string,
    usePhlebotomy: number,
    phiDOB: string,
    phiPhone: string,
    phiEmail: string,
    source: string,
    height: number,
    weight: number,
    hasBeenInTbHousehold: boolean,
    hasWorkRelatedRisk: boolean,
    hasTravelOrImmigrationRisk: boolean,
    hasStrongyloidesRisk: boolean,
    hasChagasDiseaseRisk: boolean,
    isDonorMedicallySound: boolean,
    hasHistoryOfSmoking: boolean,
    hasNutcracker: YesNoUnknown,
    medicalComments: string,
    bloodType: string,
    bloodTypeDisplay: string,
    aboASubType: AboASubType,
    aboAbSubType: AboAbSubType,
    bloodPressure: number,
    sbp: number,
    dbp: number,
    bmi: number,
    ebv: string,
    cmv: string,
    ewt: string,
    hepBAntigen: string,
    hepBAntibody: string,
    antiHcv: string,
    hiv: string,
    tbStatus: string,
    rprVdrl: string,
    whichKidney: string,
    whichKidneyAbbreviated: string,
    whichKidneyDonated: string,
    numberOfArteries: number,
    numberOfVeins: number,
    numberOfUreters: number,
    kidneyHeight: number,
    kidneyLength: number,
    kidneyWidth: number,
    kidneyVolume: number,
    urineProtein: string,
    albuminExcretion: string,
    dateOfBirth: string,
    createdOn: Date,
    createdOnUnix: number,
    dateRegistered: string,
    dateUpdated: number,
    dateGotNote: string,
    dateDonated: string,
    comments: string,
    position: number,
    statusId: number,
    surgeonContactId: number,
    surgeonContact: string,
    isAdp: boolean,
    hasEarlyBifurcation: boolean,
    earlyBifurcationLength: number,


    vRLAboUploadPath: string,
    vrlHlaUploadPath: string,
    vRLAboA2ConfirmatoryUploadPath: string,
    vRLAboMolecularUploadPath: string,
    adpFormFilePath: string,
    histogeneticsRawTypingFile: string,
    histogeneticsPdfTypingFile: string,
    histogeneticsRawAboFile: string,
    histogeneticsPdfAboFile: string,
    ctReportUploadPath: string,
    rawTypingUploadPath: string,
    medChartUploadPath: string,
    centerAboUploadPath: string,
    serologyUploadPath: string,
    covidTestUpload: string,


    centerId: number,
    rdnCenterId: number,
    rdnCenterAlias: string,
    recipientId: number,
    coordinatorId: number,
    userId: number,
    registrationId: number,
    originalRecipientId: number,
    adpRecipientId: number,
    hospitalState: string,
    hospitalZip: string,
    clusterId: number,
    originCenterId: number,
    surgeonId: number,
    center: ICenter,
    rdnCenter: ICenter,
    age: number,
    estimatedAge: number,
    logistics: IDonorLogistics,
    minWeeksUntilTransplant: string,
    maxWeeksUntilTransplant: string,
    donorStrength: string,
    stalledDonorReviewDate: string,
    creatinineClearance: number,
    creatinineCollectionMethodId: number,
    creatinineCollectionMethod: string,
    serumCreatinine: number,
    estimatedGfr2021: number,
    bp24Hour: string,
    donorCtAbnormalities: string,
    whichKidneyDescription: string,
    hlaData: IHlaData,
    adpVoucherHolders: IAdpVoucherHolder[],
    fvHoldersAllowed: number,
    fullBloodType: string,
    isAtRisk: string,
    pairMatchPower: number
    cluster: ICluster,
    ssdHtml: string,
    donationCenterId: number,
    soleSourceDonors: ISoleSourceDonor[],
    pairedRecipient: IRecipient,
    daysInNkr: number,
    storedPrePrefMatches: number,
    storedPostPrefMatches: number,
    postPrefMatchPower: number,
    storedChipMatches
}

export interface ISoleSourceDonor {
    recipientCenterId: number,
    recipientCenter: string,
    recipientCenterCprScore: number,
    recipientId: number,
    recipientAlias: string,
    recipientCpra4: number,
    recipientWaitTime: number,
    recipientDeclineRatio: number,
    patientTypeId: number,
    patientType: string,
    donorId: number,
    donorAge: number,
    donorBloodType: string,
    epletMm: ISingleEpletMmRisk
}
